import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const Signup = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    first_name: '',
    last_name: '',
    password1: '',
    password2: '',
    operation_name: '',
    unit_name: '',
    unit_city: '',
    unit_address: ''
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    // Add floating label effect
    document.querySelectorAll('.form-group input, .form-group textarea').forEach(input => {
      input.addEventListener('focus', function() {
        this.parentElement.parentElement.classList.add('focused');
      });

      input.addEventListener('blur', function() {
        if (!this.value) {
          this.parentElement.parentElement.classList.remove('focused');
        }
      });
    });

    // Success quotes animation
    let draggedQuote = null;
    let dragOffset = { x: 0, y: 0 };
    let isDragging = false;
    
    const quotes = [
      "Sucesso é ir de fracasso em fracasso sem perder o entusiasmo.",
      "Se você pode sonhar, pode fazer.",
      "Ação é a chave fundamental para todo sucesso.",
      "Feito é melhor que perfeito.",
      "A melhor forma de prever o futuro é criá-lo.",
      "Não encontre defeitos; encontre soluções.",
      "Oportunidades não acontecem. Você as cria.",
      "A sorte favorece a mente preparada.",
      "No meio da dificuldade está a oportunidade.",
      "A persistência é o caminho do êxito.",
      "Disciplina é a ponte entre metas e realizações.",
      "O sucesso é a soma de pequenos esforços repetidos diariamente.",
      "Comece onde você está. Use o que tem. Faça o que puder.",
      "Você perde 100% dos arremessos que não tenta.",
      "A jornada de mil milhas começa com um passo.",
      "A excelência não é um ato, é um hábito.",
      "Sorte é quando a preparação encontra a oportunidade.",
      "Acredite que você pode e você já está no meio do caminho.",
      "Foco é dizer não.",
      "Continue faminto. Continue tolo.",
      "Eu não falhei. Só achei 10.000 maneiras que não funcionam.",
      "Nossa maior fraqueza é desistir.",
      "O sucesso exige ação.",
      "Sonhe grande. Comece pequeno. Aja agora.",
      "O impossível é só opinião.",
      "Coragem é resistência ao medo, domínio do medo.",
      "O segredo de progredir é começar.",
      "Aquilo que não nos mata nos fortalece.",
      "A criatividade é inteligência se divertindo.",
      "A fortuna favorece os audazes.",
      "O sucesso depende de preparação.",
      "A persistência transforma o impossível em possível.",
      "Consistência vence intensidade.",
      "A vitória ama a preparação.",
      "A maior glória é levantar após cair.",
      "Sempre parece impossível até ser feito.",
      "O sucesso não é definitivo; o fracasso não é fatal.",
      "A melhor forma de aprender é fazer.",
      "A inovação distingue um líder de um seguidor.",
      "Trabalhe duro em silêncio; deixe o sucesso fazer barulho.",
      "A única forma de fazer um ótimo trabalho é amar o que faz.",
      "Não conte os dias; faça os dias contarem.",
      "Impossível é nada.",
      "O medo mata mais sonhos que o fracasso.",
      "A coragem é a primeira das qualidades humanas.",
      "A sorte favorece quem se prepara.",
      "Pequenos passos todo dia.",
      "Objetivos claros. Ação imediata.",
      "Sua vida só melhora quando você melhora.",
      "A motivação te inicia; o hábito te mantém.",
      "Fracasso é sucesso em progresso.",
      "Não espere. O tempo nunca será 'perfeito'.",
      "O entusiasmo move o mundo.",
      "Onde há vontade, há caminho.",
      "A melhor maneira de vencer é não parar."
    ];

    function createQuote() {
      const bgAnimation = document.getElementById('bgAnimation');
      if (!bgAnimation) return;
      
      const quote = document.createElement('div');
      quote.className = 'quote';
      const quoteText = quotes[Math.floor(Math.random() * quotes.length)];
      quote.innerHTML = '"' + quoteText + '"';
      
      // Position quotes only on the sides (left: 0-25% or right: 75-100%)
      const side = Math.random() < 0.5 ? 'left' : 'right';
      let leftPosition;
      if (side === 'left') {
        leftPosition = Math.random() * 25; // 0% to 25%
      } else {
        leftPosition = 75 + (Math.random() * 20); // 75% to 95%
      }
      quote.style.left = leftPosition + '%';
      
      const duration = 18 + Math.random() * 5; // 18-23 seconds
      quote.style.animationDuration = duration + 's';
      quote.dataset.originalDuration = duration;
      quote.dataset.animationStart = Date.now();
      
      const drift = (Math.random() - 0.5) * 30;
      quote.style.setProperty('--drift', drift + 'px');
      
      quote.addEventListener('mousedown', function(e) {
        if (e.button !== 0) return;
        const rect = quote.getBoundingClientRect();
        quote.style.animation = 'none';
        quote.style.top = rect.top + 'px';
        quote.style.left = rect.left + 'px';
        quote.classList.add('selected');
        quote.dataset.mouseDownX = e.clientX;
        quote.dataset.mouseDownY = e.clientY;
        quote.dataset.hasMoved = 'false';
        quote.dataset.isPotentialDrag = 'true';
        quote.dataset.clickTop = rect.top;
        quote.dataset.clickLeft = rect.left;
        e.preventDefault();
        e.stopPropagation();
      });
      
      bgAnimation.appendChild(quote);
      
      setTimeout(() => {
        if (quote.parentNode && !quote.dataset.manualPosition) {
          quote.parentNode.removeChild(quote);
        }
      }, duration * 1000);
    }

    // Global mouse move handler
    const handleMouseMove = (e) => {
      if (isDragging && draggedQuote) {
        const newX = e.clientX - dragOffset.x;
        const newY = e.clientY - dragOffset.y;
        const percentX = (newX / window.innerWidth) * 100;
        const quoteWidth = draggedQuote.offsetWidth;
        const quoteHeight = draggedQuote.offsetHeight;
        const maxX = 100 - (quoteWidth / window.innerWidth * 100);
        const constrainedX = Math.max(0, Math.min(percentX, maxX));
        const constrainedY = Math.max(0, Math.min(newY, window.innerHeight - quoteHeight));
        draggedQuote.style.left = constrainedX + '%';
        draggedQuote.style.top = constrainedY + 'px';
        return;
      }

      const allQuotes = document.querySelectorAll('.quote');
      allQuotes.forEach(function(quote) {
        if (quote.dataset.isPotentialDrag === 'true' && quote.dataset.hasMoved === 'false') {
          const mouseDownX = parseFloat(quote.dataset.mouseDownX);
          const mouseDownY = parseFloat(quote.dataset.mouseDownY);
          const deltaX = Math.abs(e.clientX - mouseDownX);
          const deltaY = Math.abs(e.clientY - mouseDownY);
          if (deltaX > 5 || deltaY > 5) {
            quote.dataset.hasMoved = 'true';
            isDragging = true;
            draggedQuote = quote;
            quote.classList.add('dragging');
            const rect = quote.getBoundingClientRect();
            dragOffset.x = e.clientX - rect.left;
            dragOffset.y = e.clientY - rect.top;
          }
        }
      });
    };

    // Global mouse up handler
    const handleMouseUp = (e) => {
      if (isDragging && draggedQuote) {
        isDragging = false;
        draggedQuote.classList.remove('dragging');
        draggedQuote.dataset.isPotentialDrag = 'false';
        draggedQuote.dataset.hasMoved = 'false';
        draggedQuote.dataset.manualPosition = 'true';
        draggedQuote = null;
      } else {
        const allQuotes = document.querySelectorAll('.quote.selected');
        allQuotes.forEach(function(quote) {
          if (quote.dataset.hasMoved === 'false') {
            quote.classList.remove('selected');
            const originalDuration = parseFloat(quote.dataset.originalDuration) || 20;
            quote.style.animation = `floatQuote ${originalDuration}s linear forwards`;
          }
        });
      }
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);

    // Create initial quotes
    for (let i = 0; i < 8; i++) {
      setTimeout(() => createQuote(), i * 2000);
    }

    const quoteInterval = setInterval(() => {
      createQuote();
    }, 3005);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      clearInterval(quoteInterval);
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error for this field
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: null
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});
    setMessage(null);

    try {
      // Validate passwords match
      if (formData.password1 !== formData.password2) {
        setErrors({ password2: 'As senhas não coincidem.' });
        setLoading(false);
        return;
      }

      // Validate password length
      if (formData.password1.length < 8) {
        setErrors({ password1: 'A senha deve ter pelo menos 8 caracteres.' });
        setLoading(false);
        return;
      }

      // Send signup request to API
      const response = await axios.post('/auth/signup', {
        username: formData.username,
        email: formData.email,
        first_name: formData.first_name,
        last_name: formData.last_name,
        password1: formData.password1,
        password2: formData.password2,
        operation_name: formData.operation_name,
        unit_name: formData.unit_name,
        unit_city: formData.unit_city,
        unit_address: formData.unit_address
      });

      if (response.data.success) {
        setMessage({ type: 'success', text: 'Cadastro realizado com sucesso! Redirecionando para o login...' });
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      }
    } catch (err) {
      console.error('Signup error:', err);
      console.error('Error response:', err.response?.data);
      console.error('Error status:', err.response?.status);
      
      if (err.response?.data) {
        const data = err.response.data;
        
        // Prioridade: error > errors > mensagem genérica
        if (data.error) {
          setMessage({ type: 'error', text: data.error });
        } else if (data.errors) {
          // Se for um objeto de erros, definir os erros específicos
          if (typeof data.errors === 'object') {
            setErrors(data.errors);
            // Mostrar mensagem genérica se houver erros de campo
            setMessage({ type: 'error', text: 'Por favor, corrija os erros nos campos acima.' });
          } else {
            setMessage({ type: 'error', text: data.errors });
          }
        } else if (typeof data === 'string') {
          setMessage({ type: 'error', text: data });
        } else if (data.message) {
          setMessage({ type: 'error', text: data.message });
        } else {
          // Mensagem padrão baseada no status
          const errorMsg = err.response.status === 400 
            ? 'Dados inválidos. Verifique os campos e tente novamente.'
            : err.response.status === 500
            ? 'Erro no servidor. Tente novamente mais tarde.'
            : 'Erro ao criar conta. Por favor, tente novamente.';
          setMessage({ type: 'error', text: errorMsg });
        }
      } else if (err.request) {
        setMessage({ type: 'error', text: 'Erro de conexão. Verifique se o servidor está rodando.' });
      } else {
        setMessage({ type: 'error', text: 'Erro ao criar conta. Por favor, tente novamente.' });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="bg-animation" id="bgAnimation"></div>

      <div className="login-container signup-container">
        <div className="logo-container">
          <div className="logo">
            <img src="/logo.png" alt="Logo do Sistema" />
          </div>
          <h1>Criar Conta</h1>
          <p className="subtitle">Preencha os dados para começar</p>
        </div>

        <form onSubmit={handleSubmit} id="signupForm">
          {message && (
            <div className={message.type === 'error' ? 'error-message' : 'help-text'}>
              <i className={`fas ${message.type === 'error' ? 'fa-exclamation-circle' : 'fa-info-circle'}`}></i>
              <span>{message.text}</span>
            </div>
          )}

          {/* Seção: Dados do Usuário */}
          <div className="signup-form-section">
            <h3><i className="fas fa-user"></i> Dados do Usuário</h3>
            
            <div className="form-group username-field">
              <label htmlFor="username">Usuário</label>
              <div className="input-container">
                <input
                  type="text"
                  id="username"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  placeholder="Digite seu usuário"
                  required
                  autoComplete="username"
                />
                <i className="fas fa-user input-icon"></i>
              </div>
              {errors.username && (
                <div className="error-message" style={{ marginTop: '8px', padding: '10px' }}>
                  <span>{Array.isArray(errors.username) ? errors.username[0] : errors.username}</span>
                </div>
              )}
            </div>
            
            <div className="form-group">
              <label htmlFor="email">E-mail</label>
              <div className="input-container">
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Digite seu e-mail"
                  required
                  autoComplete="email"
                />
                <i className="fas fa-envelope input-icon"></i>
              </div>
              {errors.email && (
                <div className="error-message" style={{ marginTop: '8px', padding: '10px' }}>
                  <span>{Array.isArray(errors.email) ? errors.email[0] : errors.email}</span>
                </div>
              )}
            </div>
            
            <div className="signup-form-row">
              <div className="form-group">
                <label htmlFor="first_name">Nome</label>
                <div className="input-container">
                  <input
                    type="text"
                    id="first_name"
                    name="first_name"
                    value={formData.first_name}
                    onChange={handleChange}
                    placeholder="Digite seu nome"
                    required
                    autoComplete="given-name"
                  />
                  <i className="fas fa-id-card input-icon"></i>
                </div>
                {errors.first_name && (
                  <div className="error-message" style={{ marginTop: '8px', padding: '10px' }}>
                    <span>{Array.isArray(errors.first_name) ? errors.first_name[0] : errors.first_name}</span>
                  </div>
                )}
              </div>
              
              <div className="form-group">
                <label htmlFor="last_name">Sobrenome</label>
                <div className="input-container">
                  <input
                    type="text"
                    id="last_name"
                    name="last_name"
                    value={formData.last_name}
                    onChange={handleChange}
                    placeholder="Digite seu sobrenome"
                    required
                    autoComplete="family-name"
                  />
                  <i className="fas fa-id-card input-icon"></i>
                </div>
                {errors.last_name && (
                  <div className="error-message" style={{ marginTop: '8px', padding: '10px' }}>
                    <span>{Array.isArray(errors.last_name) ? errors.last_name[0] : errors.last_name}</span>
                  </div>
                )}
              </div>
            </div>
            
            <div className="signup-form-row">
              <div className="form-group">
                <label htmlFor="password1">Senha</label>
                <div className="input-container">
                  <input
                    type="password"
                    id="password1"
                    name="password1"
                    value={formData.password1}
                    onChange={handleChange}
                    placeholder="Digite sua senha"
                    required
                    autoComplete="new-password"
                    minLength={8}
                  />
                  <i className="fas fa-lock input-icon"></i>
                </div>
                <small style={{ color: 'var(--color-gray-medium)', fontSize: '12px', marginTop: '5px', display: 'block' }}>
                  A senha deve ter pelo menos 8 caracteres.
                </small>
                {errors.password1 && (
                  <div className="error-message" style={{ marginTop: '8px', padding: '10px' }}>
                    <span>{Array.isArray(errors.password1) ? errors.password1[0] : errors.password1}</span>
                  </div>
                )}
              </div>
              
              <div className="form-group">
                <label htmlFor="password2">Confirmar Senha</label>
                <div className="input-container">
                  <input
                    type="password"
                    id="password2"
                    name="password2"
                    value={formData.password2}
                    onChange={handleChange}
                    placeholder="Confirme sua senha"
                    required
                    autoComplete="new-password"
                  />
                  <i className="fas fa-lock input-icon"></i>
                </div>
                {errors.password2 && (
                  <div className="error-message" style={{ marginTop: '8px', padding: '10px' }}>
                    <span>{Array.isArray(errors.password2) ? errors.password2[0] : errors.password2}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
          
          {/* Seção: Dados da Operação */}
          <div className="signup-form-section">
            <h3><i className="fas fa-building"></i> Dados da Operação</h3>
            
            <div className="form-group">
              <label htmlFor="operation_name">Nome da Operação</label>
              <div className="input-container">
                <input
                  type="text"
                  id="operation_name"
                  name="operation_name"
                  value={formData.operation_name}
                  onChange={handleChange}
                  placeholder="Ex: Clínica, Supermercado, Academia"
                  required
                />
                <i className="fas fa-briefcase input-icon"></i>
              </div>
              {errors.operation_name && (
                <div className="error-message" style={{ marginTop: '8px', padding: '10px' }}>
                  <span>{Array.isArray(errors.operation_name) ? errors.operation_name[0] : errors.operation_name}</span>
                </div>
              )}
              <small style={{ color: 'var(--color-gray-medium)', fontSize: '12px', marginTop: '5px', display: 'block' }}>
                <i className="fas fa-info-circle"></i> O código será gerado automaticamente pelo sistema.
              </small>
            </div>
          </div>
          
          {/* Seção: Dados da Unidade */}
          <div className="signup-form-section">
            <h3><i className="fas fa-map-marker-alt"></i> Dados da Unidade</h3>
            
            <div className="form-group">
              <label htmlFor="unit_name">Nome da Unidade</label>
              <div className="input-container">
                <input
                  type="text"
                  id="unit_name"
                  name="unit_name"
                  value={formData.unit_name}
                  onChange={handleChange}
                  placeholder="Ex: Copacabana, Ipanema, Barra da Tijuca"
                  required
                />
                <i className="fas fa-store input-icon"></i>
              </div>
              {errors.unit_name && (
                <div className="error-message" style={{ marginTop: '8px', padding: '10px' }}>
                  <span>{Array.isArray(errors.unit_name) ? errors.unit_name[0] : errors.unit_name}</span>
                </div>
              )}
              <small style={{ color: 'var(--color-gray-medium)', fontSize: '12px', marginTop: '5px', display: 'block' }}>
                <i className="fas fa-info-circle"></i> O código será gerado automaticamente pelo sistema.
              </small>
            </div>
            
            <div className="form-group">
              <label htmlFor="unit_city">Cidade</label>
              <div className="input-container">
                <input
                  type="text"
                  id="unit_city"
                  name="unit_city"
                  value={formData.unit_city}
                  onChange={handleChange}
                  placeholder="Ex: São Paulo, Rio de Janeiro, Belo Horizonte"
                  required
                />
                <i className="fas fa-city input-icon"></i>
              </div>
              {errors.unit_city && (
                <div className="error-message" style={{ marginTop: '8px', padding: '10px' }}>
                  <span>{Array.isArray(errors.unit_city) ? errors.unit_city[0] : errors.unit_city}</span>
                </div>
              )}
            </div>
            
            <div className="form-group">
              <label htmlFor="unit_address">Endereço</label>
              <div className="input-container" style={{ position: 'relative' }}>
                <textarea
                  id="unit_address"
                  name="unit_address"
                  value={formData.unit_address}
                  onChange={handleChange}
                  placeholder="Digite o endereço completo"
                  rows="3"
                  required
                />
                <i className="fas fa-map-pin input-icon" style={{ top: '20px' }}></i>
              </div>
              {errors.unit_address && (
                <div className="error-message" style={{ marginTop: '8px', padding: '10px' }}>
                  <span>{Array.isArray(errors.unit_address) ? errors.unit_address[0] : errors.unit_address}</span>
                </div>
              )}
            </div>
          </div>

          <button type="submit" className="login-btn" disabled={loading}>
            <i className="fas fa-user-plus"></i>
            {loading ? 'Criando Conta...' : 'Criar Conta'}
          </button>
        </form>

        <div className="signup-login-link">
          <p>Já tem uma conta?</p>
          <Link to="/login">
            <i className="fas fa-sign-in-alt"></i>
            Fazer Login
          </Link>
        </div>

      </div>
    </div>
  );
};

export default Signup;
